import '@progress/kendo-drawing';
import { defined } from './utils/functions.js';
import './math/Graph.js';
import './math/Shapes.js';
import { CASCADING, ZOOM_END, ZOOM_START, PAN, SELECT, ITEMROTATE, ITEMBOUNDSCHANGE, CHANGE, CLICK, MOUSE_ENTER, MOUSE_LEAVE, DRAG_START, DRAG, DRAG_END } from './constants.js';
import { Shape } from './dom/Shape.js';
import './svg/Rotation.js';
import './dom/DiagramElement.js';
import { shapeDefaults } from './dom/shapeDefaults.js';

function copyDefaultOptions(mainOptions, elementOptions, fields) {
    let field;
    for (let idx = 0; idx < fields.length; idx++) {
        field = fields[idx];
        if (elementOptions && !defined(elementOptions[field])) {
            elementOptions[field] = mainOptions[field];
        }
    }
}
const defaultOptions = {
    name: 'Diagram',
    theme: 'sass',
    layout: '',
    zoomRate: 0.1,
    zoom: 1,
    zoomMin: 0,
    zoomMax: 2,
    dataSource: {},
    draggable: true,
    template: '',
    autoBind: true,
    editable: {
        rotate: {},
        resize: {},
        text: true,
        tools: [],
        drag: {
            snap: {
                size: 10,
                angle: 10
            }
        },
        remove: true
    },
    pannable: {},
    selectable: {
        key: 'none'
    },
    tooltip: { enabled: true, format: '{0}' },
    copy: {
        enabled: true,
        offsetX: 20,
        offsetY: 20
    },
    shapeDefaults: shapeDefaults({ undoable: true }),
    connectionDefaults: {
        editable: {
            tools: []
        },
        type: CASCADING
    },
    shapes: [],
    connections: []
};
const events = [
    ZOOM_END,
    ZOOM_START,
    PAN, SELECT,
    ITEMROTATE,
    ITEMBOUNDSCHANGE,
    CHANGE,
    CLICK,
    MOUSE_ENTER,
    MOUSE_LEAVE,
    'toolBarClick',
    'save',
    'cancel',
    'edit',
    'remove',
    'add',
    'dataBound',
    DRAG_START,
    DRAG,
    DRAG_END
];
function splitDiagramElements(elements) {
    const connections = [];
    const shapes = [];
    let element, idx;
    for (idx = 0; idx < elements.length; idx++) {
        element = elements[idx];
        if (element instanceof Shape) {
            shapes.push(element);
        }
        else {
            connections.push(element);
        }
    }
    return {
        shapes: shapes,
        connections: connections
    };
}
function preventDefault(e) {
    e.preventDefault();
}
function elementOffset(element) {
    const rect = element.getBoundingClientRect();
    const doc = element.ownerDocument;
    const scrollLeft = doc.defaultView.scrollX || doc.documentElement.scrollLeft || 0;
    const scrollTop = doc.defaultView.scrollY || doc.documentElement.scrollTop || 0;
    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
    };
}
function outerWidth(element, includeMargins = false) {
    let widthValue = element.offsetWidth; // Width of the element with padding and border
    if (includeMargins) {
        const style = getComputedStyle(element);
        const marginLeft = parseFloat(style.marginLeft);
        const marginRight = parseFloat(style.marginRight);
        widthValue += marginLeft + marginRight;
    }
    return widthValue;
}
function outerHeight(element, includeMargins = false) {
    let heightValue = element.offsetHeight;
    if (includeMargins) {
        const style = getComputedStyle(element);
        const marginTop = parseFloat(style.marginTop);
        const marginBottom = parseFloat(style.marginBottom);
        heightValue += marginTop + marginBottom;
    }
    return heightValue;
}
function elementWidth(element) {
    const style = getComputedStyle(element);
    const widthValue = element.clientWidth; // Includes content + padding
    const paddingLeft = parseFloat(style.paddingLeft);
    const paddingRight = parseFloat(style.paddingRight);
    return widthValue - paddingLeft - paddingRight; // Only content
}
function elementHeight(element) {
    const style = getComputedStyle(element);
    const heightValue = element.clientHeight;
    const paddingTop = parseFloat(style.paddingTop);
    const paddingBottom = parseFloat(style.paddingBottom);
    return heightValue - paddingTop - paddingBottom;
}

export { copyDefaultOptions, defaultOptions, elementHeight, elementOffset, elementWidth, events, outerHeight, outerWidth, preventDefault, splitDiagramElements };
